import { render, staticRenderFns } from "./CurrentData.vue?vue&type=template&id=4fe2468a&"
import script from "./CurrentData.vue?vue&type=script&lang=js&"
export * from "./CurrentData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports